import { render, staticRenderFns } from "./TableVagas.vue?vue&type=template&id=2ca62106&scoped=true&"
import script from "./TableVagas.vue?vue&type=script&lang=js&"
export * from "./TableVagas.vue?vue&type=script&lang=js&"
import style0 from "./TableVagas.vue?vue&type=style&index=0&id=2ca62106&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca62106",
  null
  
)

export default component.exports